import gql from 'graphql-tag';

export const REVOKE_INVITATION_MUTATION = gql`
  mutation revokeSharedTicket($token: String, $ticketId: Int!) {
    viewer(token: $token) {
      wasRevoked: revokeTicket(ticketId: $ticketId)
    }
  }
`;
